import React from 'react';
import classnames from 'classnames';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog/popup-dialog';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import classes from './remove-goodie-product-popup.scss';
const titleClasses = {
  root: classes.titleContainer
};
const footerClasses = {
  spacing: classes.footer
};
const popupClasses = {
  paper: classnames(classes.popupContainer, classes.popup)
};
export const RemoveGoodieProductPopup = ({
  open,
  product,
  link,
  onClose,
  onConfirm,
  buttonColor
}) => {
  const handleConfirm = () => {
    onConfirm(product, link);
  };
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: onClose,
    title: "Remove product",
    dataPopup: "RemoveGoodieProductPopup",
    footerClasses: footerClasses,
    classes: popupClasses,
    titleClasses: titleClasses,
    titleHeader: classes.title,
    contentClass: classes.content,
    closeClass: classes.closeButton,
    closeStyles: {
      backgroundColor: buttonColor
    },
    popupClassName: classes.rootPopup,
    content: /*#__PURE__*/React.createElement("div", {
      className: classes.body
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.hint
    }, "Are you sure you want to delete", ' ', /*#__PURE__*/React.createElement("b", {
      style: {
        color: buttonColor
      }
    }, (product === null || product === void 0 ? void 0 : product.name) || ''), " product?"), /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, /*#__PURE__*/React.createElement(Button, {
      className: classnames(classes.button, classes.cancel),
      dataButton: "Cancel",
      type: ButtonType.fullGreyGreyText,
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      dataButton: "Confirm",
      className: classes.button,
      style: {
        backgroundColor: buttonColor,
        borderColor: buttonColor
      },
      type: ButtonType.primary,
      onClick: handleConfirm
    }, "Confirm")))
  });
};